import { render, staticRenderFns } from "./subjectMutilSelect.vue?vue&type=template&id=80b90afe&"
import script from "./subjectMutilSelect.vue?vue&type=script&lang=js&"
export * from "./subjectMutilSelect.vue?vue&type=script&lang=js&"
import style0 from "./subjectMutilSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports